import prettyBytes from "pretty-bytes";

import { AttemptedRowFieldsOmittedReason } from "src/graphql";

type RowWithOmittedFields = {
  fieldsOmittedBytes?: number | null;
  fieldsOmittedReason?: AttemptedRowFieldsOmittedReason | null;
};

export const omittedFieldsMessage = ({
  fieldsOmittedBytes,
  fieldsOmittedReason,
}: RowWithOmittedFields): string | null => {
  switch (fieldsOmittedReason) {
    case AttemptedRowFieldsOmittedReason.RowTooLarge:
      return fieldsOmittedBytes
        ? `This row is ${prettyBytes(fieldsOmittedBytes)}, too large to show its fields. Query your model to see its values.`
        : "This row is too large to show its fields. Query your model to see its values.";
    case AttemptedRowFieldsOmittedReason.PageTooLarge:
      return "This page's rows are too large to show together. Open the row to see its fields.";
    default:
      return null;
  }
};
